module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_chap01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_vm._v("Chapter 1")]), _vm._v(" Mike Sharman - A Pioneer Modeller of Early Railways")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_chap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_vm._v("Chapter 2")]), _vm._v(" Infrastructure")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_vm._v("Chapter 3")]), _vm._v(" Locomotives")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_vm._v("Chapter 4")]), _vm._v(" Carriages")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_vm._v("Chapter 5")]), _vm._v(" Wagons")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_vm._v("Chapter 6")]), _vm._v(" Layouts and models")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f_toc"
  }, [_vm._v("Appendix")]), _vm._v(" Sources of supply for modellers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0